module.exports = __webpack_public_path__ + "img/infp.fa70a18f.png";